export default {
  setEscalaItem(state, data) {
    state.escala_item = data;
  },
  setEscalasItens(state, data) {
    state.escalas_itens = data;
  },
};
